export var firebaseConfig = {
    apiKey: "AIzaSyDOnnh-de7ReU0hRC1y81bqg8puOzXRlpQ",
    authDomain: "s3cretm3.firebaseapp.com",
    databaseURL: "https://s3cretm3.firebaseio.com",
    projectId: "s3cretm3",
    storageBucket: "s3cretm3.appspot.com",
    messagingSenderId: "449185852114",
    appId: "1:449185852114:web:17324b67a5a67c05bedb0b",
    measurementId: "G-LBMPRDZ0RM"
};
